import React from "react";

/**
 * Blank page for redirect purposes. When using popup and silent APIs,
 * we recommend setting the redirectUri to a blank page or a page that does not implement MSAL.
 * For more information, please follow this link:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations
 */

export const Blank = () => {
  return <div />;
};
